<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('courses')"
      :columns="columns"
      :column_search="true"
      resource_url="/student/course/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <course-modal ref="course_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import CourseModal from "./course_modal/Index.vue";

export default {
  name: "CoursesDatatable",
  components: { GenericTable, CourseModal },
  data() {
    let v = this;
    return {
      columns: [
        // {
        //   title: v.$t("id card number"),
        //   name: "id_card_number",
        //   searchable: true,
        //   width: "30%",
        //   data: (row) => {
        //     return row.id_card_number || "";
        //   },
        // },
        {
          title: v.$t("name"),
          searchable: false,
          // width: "30%",
          data: (row) => {
            return row.name || "";
            // return `${row.first_name} ${row.surname}`;
          },
        },
        // {
        //   title: v.$t("inscriptions"),
        //   searchable: false,
        //   // width: "30%",
        //   data: (row) => {
        //     let r = "";
        //     if (
        //       row.student_inscriptions &&
        //       row.student_inscriptions.length > 0
        //     ) {
        //       r = row.student_inscriptions
        //         .map((i) => {
        //           return `<span class="tag is-info">${i.program.name}</span>`;
        //         })
        //         .join(" ");
        //     }
        //     return r;
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.course_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete course?"),
                    v,
                    () => {
                      del("/student/course", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.course_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
